export default {
  state: {
    filter: {
      search: '',
      status: '',
      date: 'withinDay',
      dateFrom: '',
      dateTo: '',
      loading: false,
      brand: ''
    }
  },
  mutations: {
    resetFilters (state, value) {
      state.filter = {
        search: '',
        status: '',
        date: 'withinDay',
        dateFrom: '',
        dateTo: '',
        loading: false,
        brand: ''
      }
    },
    setSearch (state, value) { state.filter.search = value },
    setStatus (state, value) { state.filter.status = value },
    setDate (state, value) { state.filter.date = value },
    setDateFrom (state, value) { state.filter.dateFrom = value },
    setDateTo (state, value) { state.filter.dateTo = value },
    setBrand (state, value) { state.filter.brand = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/transactions/filters.js